import { getStatusClasses } from "@/components/ui/status-badge";
import { Eye } from "lucide-react";
import { MobileCardsSkeleton } from "@/components/shared/mobile-cards-skeleton";
import type { RequestHistoryItem } from "../modals/types";

interface RequestHistoryMobileCardsProps {
  paginatedItems: RequestHistoryItem[];
  filteredItems: RequestHistoryItem[];
  loading: boolean;
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  onView: (item: RequestHistoryItem) => void;
}

export function RequestHistoryMobileCards({
  paginatedItems,
  filteredItems,
  loading,
  onView,
}: RequestHistoryMobileCardsProps) {

return (
    <div
      className="border rounded-lg overflow-hidden bg-card border-border transition-colors"
    >
      <div className="space-y-3 p-4">
        {loading ? (
          <MobileCardsSkeleton count={6} showHeader={false} />
        ) : filteredItems.length === 0 ? (
          <div className="text-center py-8 text-muted-foreground text-sm">
            No processed requests found
          </div>
        ) : (
          paginatedItems.map((item) => (
            <div
              key={item.id}
              className="p-4 rounded-lg border bg-card border-border"
            >
              <div className="flex justify-between items-start mb-3">
                <div>
                  <p className="font-semibold text-sm">
                    {item.requested_by_name}
                  </p>
                </div>
                <div className="flex flex-col gap-1 items-end">
                  <span
                    className={`px-2 py-1 rounded-full text-xs font-semibold ${getStatusClasses(
                      item.status
                    )}`}
                  >
                    {item.status_display || item.status}
                  </span>
                  <span className={`px-2 py-1 rounded-full text-xs font-semibold ${getStatusClasses(item.processing_status)}`}>
                    {item.processing_status_display || item.processing_status}
                  </span>
                </div>
              </div>
              <div className="space-y-1 mb-3 text-xs">
                <div className="flex justify-between">
                  <span className="text-muted-foreground">For:</span>
                  <span className="font-medium">{item.requested_for_name}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Points:</span>
                  <span className="font-medium">
                    {item.total_points.toLocaleString()} pts
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Date:</span>
                  <span className="font-medium">
                    {new Date(item.date_requested).toLocaleDateString()}
                  </span>
                </div>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => onView(item)}
                  className="flex-1 px-3 py-2 rounded-lg text-xs font-semibold transition-colors flex items-center justify-center gap-1 bg-primary hover:bg-primary/90 text-primary-foreground"
                >
                  <Eye className="h-4 w-4" />
                  View
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
